import React, { useContext, useMemo } from 'react'
import { rankWith, and, scopeEndsWith } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'

import ComponentWrapper from 'designer/component/display/layout/control/ComponentWrapper'
import DragContainerWrapper from 'designer/component/system/layout/control/DragContainerWrapper'
import CustomPanel from 'designer/component/container/panel/Panel'

import {
  createDisplayRenderer,
  createSystemRenderer,
} from 'designer/component/control/renderer'
import { DesignContext } from 'contexts/DesignContext'
import FormLoading from 'components/Loader/FormLoading'
import objectPath from 'object-path'
import Container from './Container'

const panelTester = rankWith(
  3,
  and(scopeEndsWith('panel'), (schema) => !schema.subGroup),
)

const subPanelTester = rankWith(
  3,
  and(scopeEndsWith('panel'), (schema) => schema.subGroup),
)

export const PanelSystem = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomPanel {...props}>
        <Container {...props} renderers={renderers} />
      </CustomPanel>
    </DragContainerWrapper>
  )
}

export const SubPanelSystem = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createSystemRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  return (
    <DragContainerWrapper {...props}>
      <CustomPanel {...props}>
        <Container {...props} renderers={renderers} />
      </CustomPanel>
    </DragContainerWrapper>
  )
}

export const PanelDisplay = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  const designContext = useContext(DesignContext)
  const { elementAction } = designContext
  const isLoading = objectPath.get(elementAction, ['isLoading', uischema.key])

  if (isLoading) {
    return (
      <div className="w-100">
        <FormLoading />
      </div>
    )
  }

  return (
    <ComponentWrapper {...props}>
      <CustomPanel {...props}>
        <Container {...props} renderers={renderers} />
      </CustomPanel>
    </ComponentWrapper>
  )
}

export const SubPanelDisplay = (props) => {
  let { data, schema, uischema, handleChange, path, config } = props
  const renderers = useMemo(
    () => createDisplayRenderer(uischema.elements),
    [JSON.stringify(uischema.elements)],
  )

  const designContext = useContext(DesignContext)
  const { elementAction } = designContext
  const isLoading = objectPath.get(elementAction, ['isLoading', uischema.key])

  if (isLoading) {
    return (
      <div className="w-100">
        <FormLoading />
      </div>
    )
  }

  return (
    <ComponentWrapper {...props}>
      <CustomPanel {...props}>
        <Container
          {...props}
          uischema={{ type: 'VerticalLayout', elements: uischema.elements }}
          renderers={renderers}
        />
      </CustomPanel>
    </ComponentWrapper>
  )
}

export const panelSystem = {
  tester: panelTester,
  renderer: withJsonFormsControlProps(PanelSystem),
}

export const subPanelSystem = {
  tester: subPanelTester,
  renderer: withJsonFormsControlProps(SubPanelSystem),
}

export const panelDisplay = {
  tester: panelTester,
  renderer: withJsonFormsControlProps(PanelDisplay),
}

export const subPanelDisplay = {
  tester: subPanelTester,
  renderer: withJsonFormsControlProps(SubPanelDisplay),
}
